<div class="appHeader" *ngIf="!isPublicRoute">
  <mat-toolbar *ngIf="!adminModule">
    <mat-toolbar-row class="main-toolbar">
      <div class="menu-wrapper">
        <button (click)="closeSidenav(false)" mat-icon-button>
          <i class="icon-burger color-base-1"></i>
        </button>
        <div class="logo-wrapper">
          <a [routerLink]="['/homepage']"><img src="assets/images/logo-white-horizontal.svg" alt="divinea" /></a>
        </div>
      </div>


      <!-- <div>
        <span *ngIf="!!!!versionPostfix" class="version"
          >{{ version }} ({{ versionPostfix }})</span
        >
        <span *ngIf="!!!versionPostfix" class="version">{{ version }}</span>
        <span *ngIf="!!!!versionRibbon" class="ribbon">{{
          versionRibbon
        }}</span>
      </div> -->

      <div class="actions-wrapper">
        <ng-container *ngIf="downloadsService.downloads$ | async as downloads">
          <ng-container *ngIf="downloads.length">
            <button [matMenuTriggerFor]="downloadsMenu" mat-icon-button style="margin-right: 15px">
              <mat-icon class="color-base-1">download</mat-icon>
              <span class="tip notifications-number downloads-count">{{ downloads.length }}</span>
            </button>

            <mat-menu #downloadsMenu="matMenu" class="notification-menu downloads-menu">
              <header>
                <h2>{{ 'downloads.title' | translate }}</h2>
              </header>
              <mat-divider></mat-divider>
              <div *ngFor="let item of downloads" class="download-progress-item" (click)="$event.stopPropagation()">
                <div class="download-progress-header">
                  <mat-icon class="download-progress-icon">{{ item.status === 'ready' ? 'file_download' : 'download'
                    }}</mat-icon>
                  <span class="download-progress-label" [wsTooltip]="item.label" wsTooltipShowDelay="300">
                    {{ item.label }}
                  </span>
                  <button *ngIf="item.status === 'ready' && item.download" type="button"
                    class="download-progress-cancel" mat-icon-button
                    (click)="$event.stopPropagation(); item.download!()"
                    [attr.aria-label]="'downloads.downloadFile' | translate"
                    [wsTooltip]="'downloads.downloadFile' | translate" wsTooltipShowDelay="300">
                    <mat-icon>download</mat-icon>
                  </button>
                  <button *ngIf="item.cancel && item.status === 'running'" type="button"
                    class="download-progress-cancel" mat-icon-button (click)="$event.stopPropagation(); item.cancel!()"
                    [attr.aria-label]="'payments.advancedExport.stopExport' | translate"
                    [wsTooltip]="'payments.advancedExport.stopExport' | translate" wsTooltipShowDelay="300">
                    <mat-icon>close</mat-icon>
                  </button>
                  <button *ngIf="item.dismiss && item.status === 'ready'" type="button" class="download-progress-cancel"
                    mat-icon-button (click)="$event.stopPropagation(); item.dismiss!()"
                    [attr.aria-label]="'downloads.dismiss' | translate" [wsTooltip]="'downloads.dismiss' | translate"
                    wsTooltipShowDelay="300">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
                <div class="download-progress-track" *ngIf="item.status === 'running'">
                  <div class="download-progress-fill" [style.width.%]="downloadProgressPercent(item)">
                  </div>
                </div>
                <span *ngIf="item.hint" class="download-progress-hint">{{ item.hint }}</span>
              </div>
            </mat-menu>
          </ng-container>
        </ng-container>

        <button
          [matMenuTriggerFor]="asyncJobsMenu"
          mat-icon-button
          style="margin-right: 10px"
          [wsTooltip]="'Background jobs' | translate"
        >
          <mat-icon class="color-base-1">work_history</mat-icon>
          <span
            *ngIf="(asyncJobsRunningCount$ | async)! > 0"
            class="tip notifications-number"
            >{{ asyncJobsRunningCount$ | async }}</span
          >
        </button>

          <mat-menu
            #asyncJobsMenu="matMenu"
            class="notification-menu"
          >
            <header>
              <h2>{{ "Background jobs" | translate }}</h2>
            </header>
            <mat-divider></mat-divider>
            <ng-container *ngFor="let job of asyncJobs$ | async">
              <div>
                <button mat-menu-item class="async-job-menu-entry">
                  <div
                    class="async-job-row"
                    (click)="$event.stopPropagation()"
                  >
                    <div class="leftBarNotification">
                      <span
                        *ngIf="isAsyncJobRunning(job)"
                        class="dot icon-notification-color"
                      ></span>
                    </div>
                    <div class="rightBarNotification async-job-body">
                      <div class="notification-txt">
                        <strong>
                          <mat-icon class="notification-single-icon"
                            >work_history</mat-icon
                          >
                          {{ job.label }}
                        </strong>
                        <span class="notification-message">{{
                          job.status | translate
                        }}</span>
                      </div>
                      <p class="time-txt">
                        {{
                          job.completedAt
                            ? (job.completedAt | date: "dd/MM HH:mm")
                            : (job.lastUpdatedAt | date: "dd/MM HH:mm")
                        }}
                      </p>
                    </div>
                    <div
                      *ngIf="isAsyncJobReportDownloadable(job)"
                      class="async-job-downloads"
                    >
                      <button
                        mat-icon-button
                        type="button"
                        [matMenuTriggerFor]="jobReportDownloadMenu"
                        (click)="$event.stopPropagation()"
                        [wsTooltip]="'Download report' | translate"
                      >
                        <mat-icon>download</mat-icon>
                      </button>
                      <mat-menu
                        #jobReportDownloadMenu="matMenu"
                        class="async-job-report-download-menu"
                      >
                        <button
                          type="button"
                          mat-menu-item
                          (click)="
                            downloadAsyncJobReportCsv($event, job.jobId)
                          "
                        >
                          <mat-icon>description</mat-icon>
                          <span>{{
                            "Download CSV report" | translate
                          }}</span>
                        </button>
                        <button
                          type="button"
                          mat-menu-item
                          (click)="
                            downloadAsyncJobReportExcel($event, job.jobId)
                          "
                        >
                          <mat-icon>grid_on</mat-icon>
                          <span>{{
                            "Download Excel report" | translate
                          }}</span>
                        </button>
                      </mat-menu>
                    </div>
                  </div>
                </button>
              </div>
            </ng-container>
            <div *ngIf="(asyncJobs$ | async)?.length === 0" class="dws-button-load-more">
              <span style="font-style: italic; font-size: 13px;">{{ "No background jobs found" | translate }}</span>
            </div>
          </mat-menu>

        <button
          [matMenuTriggerFor]="messaggingMenu"
          mat-icon-button
          style="margin-right: 15px"
        >
          <mat-icon class="color-base-1"> chat_bubble_outline</mat-icon>
          <span *ngIf="newMessages > 0" class="tip notifications-number">{{
            newMessages
            }}</span>
        </button>

        <mat-menu #messaggingMenu="matMenu" (close)="messaggesClosed()" class="notification-menu messaging-menu"
          style="margin-right: 10px">
          <header>
            <h2>
              {{ "Messages" | translate }}
            </h2>
            <a (click)="messagesAllDismiss()" class="dismissAllLink">{{
              "Set all as readed" | translate
              }}</a>
          </header>
          <div class="dws-button-filter-selector">

            <mat-button-toggle-group (change)="onChangeVisualization($event, 'messages')"
              (click)="onNotificationVisualizationClick($event)" aria-label="Message Filter" name="messagesFilter"
              value="all">
              <mat-button-toggle value="all">{{
                "All" | translate
                }}</mat-button-toggle>
              <mat-button-toggle value="unreaded">{{
                "Unread" | translate
                }}</mat-button-toggle>
            </mat-button-toggle-group>
          </div>
          <mat-divider></mat-divider>
          <div class="notification-panel-list" (scroll)="onMessagesListScroll($event)">
            <div *ngFor="let message of messages$ | async; let i = index">

              <button (click)="openMessage(message)" mat-menu-item>
                <div class="leftBarNotification">
                  <span *ngIf="!message.viewed_at" class="dot icon-notification-color"></span>

                </div>
                <div class="rightBarNotification">
                  <div class="notification-txt">
                    <strong>
                      <mat-icon class="notification-single-icon">chat_bubble_outline</mat-icon>
                      {{ translateNotificationTitle(message?.title) }}</strong>
                    <span class="notification-message">{{
                      translateNotificationMessage(message?.message)
                      }}</span>
                  </div>
                  <p class="time-txt">

                    {{ formatDate(message?.send_at) }}
                  </p>
                </div>
              </button>
            </div>
            <p *ngIf="messagesLoading" class="notification-panel-loading">
              {{ "Loading..." | translate }}
            </p>
          </div>
        </mat-menu>

        <button [matMenuTriggerFor]="notificationMenu" mat-icon-button>
          <i class="icon-notification color-base-1"></i>
          <span class="tip notifications-number" *ngIf="newNotification > 0">{{
            newNotification
            }}</span>
        </button>

        <mat-menu class="notification-menu" #notificationMenu="matMenu" (close)="notificationsClosed()">
          <web-notification-panel [notifications]="notifications$ | async" [onlyUnread]="onlyUnreadedNotification"
            [noMore]="noMoreNotifications" [loading]="notificationsLoading" [unreadCount]="newNotification"
            (filterChange)="onNotificationPanelFilter($event)" (dismissAll)="notificationsAllDismiss()"
            (notificationClick)="openNotification($event)"
            (scrollDown)="onScrollDownNotification()"></web-notification-panel>
        </mat-menu>

        <button class="helpMenuButtonTopbar" mat-icon-button [matMenuTriggerFor]="helpMenu">
          <span>{{ "Support" | translate }}</span>
          <i class="icon-faq color-base-1"></i>
        </button>

        <mat-menu #helpMenu="matMenu">
          <button class="helpMenuButton" mat-menu-item (click)="openManual()">
            <span>{{ "Guides and Manual" | translate }}</span>
            <mat-icon class="helpMenuButtonIcon">menu_book</mat-icon>
          </button>
          <button mat-menu-item class="helpMenuButton" (click)="openHelp()">
            <span>{{ "Need Help" | translate }}</span>
            <mat-icon class="helpMenuButtonIcon">contact_support</mat-icon>
          </button>
        </mat-menu>

        <!-- Theme Toggle Component -->
        <app-theme-toggle *ngIf="this.showThemeSelector"></app-theme-toggle>

        <!-- Logo winery image -->
        <span *ngIf="logoImage">
          <img class="winery-logo" [src]="logoImage" [hidden]="!showLogo" (load)="onLogoLoad()" alt="Winery Logo" />
        </span>

        <ng-container *ngIf="selfAccount$ | async as account">
          <button mat-button [matMenuTriggerFor]="accountMenu">
            <span class="color-base-1">{{ account.name }}</span>
          </button>

          <mat-menu class="account-menu" #accountMenu="matMenu">
            <div class="profile">
              <!--              <div class="avatar">-->
              <!--                <img src="assets/images/avatar.png" />-->
              <!--              </div>-->

              <strong>{{ account.name }}</strong>
              <span>{{ account.email }}</span>
            </div>

            <div class="actions">
              <button mat-stroked-button [routerLink]="['/account-detail']">
                {{ "My Account" | translate }}
              </button>
              <button mat-stroked-button (click)="logoutClicked()">
                {{ "Logout" | translate }}
              </button>
              <!-- <button
                  mat-stroked-button
                  (click)="googleCalendarLinkClicked()"
                style="background-color: lightgrey;"
                  [wsTooltip]="'This will be removed soon, please use the new Integrations section' | translate">
                  {{ "Link Google Calendar" | translate }}
                </button>
                <button
                  mat-stroked-button
                  (click)="outlookCalendarLinkClicked()"
                style="background-color: lightgrey;"
                  [wsTooltip]="'This will be removed soon, please use the new Integrations section' | translate">
                  {{ "Link Outlook Calendar" | translate }}
                </button> -->
              <mat-divider class="paddingTop1"></mat-divider>
              <div class="privacy-link paddingTop1">
                <a href="/privacy" target="_blank">{{
                  "Privacy Terms" | translate
                  }}</a>
              </div>
            </div>
          </mat-menu>
        </ng-container>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>

  <mat-toolbar *ngIf="adminModule">
    <mat-toolbar-row class="main-toolbar">
      <div class="menu-wrapper"></div>

      <div class="logo-wrapper">
        <a [routerLink]="['/dashboard']"><img src="assets/images/logo-white-horizontal.svg" alt="divinea" /></a>
      </div>

      <span>{{ version }}</span>

      <div class="actions-wrapper">
        <!-- Theme Toggle Component for Admin -->
        <app-theme-toggle></app-theme-toggle>

        <ng-container *ngIf="adminAuth$ | async as auth">
          <button mat-button [matMenuTriggerFor]="accountMenu">
            <span class="color-base-1">{{ auth.username }}</span>
          </button>

          <mat-menu class="account-menu" #accountMenu="matMenu">
            <div class="profile">
              <!--              <div class="avatar">-->
              <!--                <img src="assets/images/avatar.png" />-->
              <!--              </div>-->

              <strong>{{ auth.username }}</strong>
            </div>

            <div class="actions">
              <button mat-stroked-button (click)="logoutAdminClicked()">
                {{ "Logout" | translate }}
              </button>
            </div>
          </mat-menu>
        </ng-container>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>


  <!-- <mat-toolbar (mouseleave)="hideBanner($event)" (mouseover)="hideBanner($event)" -->
  <div *ngIf="showBanner && displayBanners.length" class="app-top-banners">
    <div *ngFor="let banner of displayBanners; trackBy: trackBannerById" class="app-top-banner-item">
      <ws-banner [previewData]="banner"></ws-banner>
    </div>
  </div>
</div>
<div class="appSubHeader" *ngIf="!isPublicRoute && hasHeader()">
  <ws-page-header #wsPageHeader class="title-toolbar"> </ws-page-header>
</div>
<mat-sidenav-container *ngIf="!isAdminSection()" class="sidenav-container" (backdropClick)="closeSidenav(true)"
  [ngClass]="{ public: isPublicRoute, hasHeader: hasHeader() }">
  <mat-sidenav id="menu" (keydown.escape)="closeSidenav(true)" #sidenav mode="side" hasBackdrop="false"
    [class.opened]="isSidenavOpen" [class.closed]="!isSidenavOpen" [opened]="true" disableClose="true"
    *ngIf="!isPublicRoute">
    <ws-menu [dwsPro]="dwsPro" [isOpen]="isSidenavOpen" (isOpenChange)="isSidenavOpen = $event" [versionText]="version"
      [versionPostfix]="versionPostfix"></ws-menu>
  </mat-sidenav>
  <mat-sidenav-content [class.with-sidenav-opened]="isSidenavOpen" [class.with-sidenav-closed]="!isSidenavOpen"
    style="overflow: hidden;">
    <div class="content-wrapper-ws" [ngClass]="loginPageClass">
      <div class="content-wrapper-subtitle" *ngIf="!isPublicRoute && hasSubHeader()">
        <ws-page-subheader></ws-page-subheader>
      </div>
      <div class="content-wrapper-ws-internal" [class.isNewGraphic]="isNewGraphic()"
        [class.integrations]="isIntegrations" [ngClass]="loginPageClass">
        <!-- Dynamic sidenav content -->
        <ng-container *ngIf="sidenavContent; else routerOutlet">
          <ng-container *ngComponentOutlet="sidenavContent.component"></ng-container>
        </ng-container>

        <!-- Default router outlet -->
        <ng-template #routerOutlet>
          <router-outlet></router-outlet>
        </ng-template>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
<div class="superAdminContainer" *ngIf="isAdminSection()" [ngClass]="loginPageClass">
  <router-outlet></router-outlet>
</div>


<app-loading *ngIf="isLoading"></app-loading>
<ws-tooltip-root></ws-tooltip-root>

<web-common-message-popup *ngIf="!isPublicRoute && !adminModule"></web-common-message-popup>